function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11569_111586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.94 18.4527C16.2306 19.7557 14.1491 20.4776 12 20.5127C5 20.5127 1 12.5127 1 12.5127C2.24389 10.1946 3.96914 8.16933 6.06 6.57272M9.9 4.75272C10.5883 4.5916 11.2931 4.51106 12 4.51272C19 4.51272 23 12.5127 23 12.5127C22.393 13.6483 21.6691 14.7175 20.84 15.7027M14.12 14.6327C13.8454 14.9275 13.5141 15.1639 13.1462 15.3278C12.7782 15.4918 12.3809 15.58 11.9781 15.5871C11.5753 15.5942 11.1752 15.5201 10.8016 15.3692C10.4281 15.2183 10.0887 14.9937 9.80385 14.7089C9.51897 14.424 9.29439 14.0847 9.14351 13.7111C8.99262 13.3376 8.91853 12.9374 8.92563 12.5346C8.93274 12.1318 9.02091 11.7346 9.18488 11.3666C9.34884 10.9986 9.58525 10.6674 9.88 10.3927",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1.5127L23 23.5127",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11569_111586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0 0.512695)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.1400e5ee6d00351196e11f3034624f07.svg";
export { ForwardRef as ReactComponent };